import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.scss';
import Home from './components/Home/Home';
/* import Footer from './components/Footer/Footer'; */
import Header from './components/Header/Header';
import Produtos from './components/Produtos/Produtos';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import HeaderMobile from './components/HeaderMobile/HeaderMobile';
import News from './components/Admin/Admin';

const getBasename = path => path.substr(0, path.lastIndexOf('/'));

class App extends Component {



  render() {

    return (
      <>
        <Router basename={getBasename(window.location.pathname)}>
          {window.screen.availWidth <= 768 ? <HeaderMobile /> : <Header />}
          <Switch>
            <Route exact path='/' component={Home}>
            </Route>
            <Route exact path='/produtos' component={Produtos}>
            </Route>
            <Route exact path='/news' component={News}>
            </Route>
            <Route path='*' component={Home}>
            </Route>
          </Switch>
          {/*  <Footer /> */}

        </Router>
        <a href="https://api.whatsapp.com/send?phone=5496319065" rel="noreferrer" className="botao_whats" target="_blank">
          <WhatsAppIcon className="whats" fontSize="large" />
        </a>
      </>
    );
  }
}



export default App;
